import api from "../../Api/feathers-client";

// // Call backend service to update defs
export const getRolesBySiteUuid = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("roles").find(params);
      resolve({
        status: 200,
        message: "All Roles By Site Uuid",
        data: response.data,
      });
    } catch (error) {         
      resolve(error);
    }
  });
};

export const getUsersByRoleId = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("users").find(params);
      resolve({
        status: 200,
        message: "All Users By role uid",
        data: response,
      });
    } catch (error) {         
      resolve(error);
    }
  });
};

export const updateUsersAction = async (id, data, params) => {
  // allowedweblogin true/false, set user delete
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("users").patch(id,data,params);
      console.log("response",response);
      resolve({
        status: 200,
        message: "All Users Updated",
        data: response.data ? response.data : response[0],
      });
    } catch (error) {         
      resolve(error);
    }
  });
};

export const deletePermanentUsers = async (id, data, params) => {
  // set username and passcode prefix with "del_" keyword
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("getUserData").patch(id,data,params);
      resolve({
        status: 200,
        message: "All Users Updated",
        data: response.data,
      });
    } catch (error) {         
      resolve(error);
    }
  });
};

export const createUser = async (data) => {
  // set username and passcode prefix with "del_" keyword
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("users").create(data);
      resolve({
        status: 200,
        message: "User Created",
        response,
      });
    } catch (error) {         
      resolve({
        status: error.code,
        message: error.message,
        data: data,
      });
    }
  });
};

export const fetchUserByUid = async (params) => {
  // fetch user's by it's uids
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("users").find(params);
      resolve({
        status: 200,
        message: "Get User",
        data: response,
      });
    } catch (error) {         
        resolve(error);
      };
  })
}

// Return user's name in normal formate from json formate
export const formateName = (nameJson) => {
  let name = "";
  if (nameJson.firstname) {
    name += nameJson.firstname;
  }
  if (nameJson.middlename) {
    name += " " + nameJson.middlename;
  }
  if (nameJson.lastname) {
    name += " " + nameJson.lastname;
  }

  return name;
};